export enum EventType {
  click = 'click',
  pageView = 'pageview',
  global = 'global',
  custom = 'custom',
}

export enum IntegrationType {
  iframe = 'iframe',
  inDom = 'indom',
  webComponent = 'webcomponent',
  vueComponent = 'vuecomponent',
}
